module.exports = __webpack_public_path__ + "static/img/djkx2.9f4874e.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/djkx2.jpeg
// module id = iSmv
// module chunks = 1